import React from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { History } from "history";
import { Link } from "@amzn/awsui-components-react-v3";
import AmazonCrewLogo from "../../svg/AmazonCrew";
import { AutoSuggestItem } from "../../search/AutoSuggestResponse";
import EntityType from "../../search/EntityType";

import styles from "./header.module.css";
import AutoSuggest from "../../search/AutoSuggest";
import {
  getCurrentEnvironment,
  Environment,
} from "../../common/featureFlagUtils";

import {
  getDefinedPresets,
  DefinedPresets,
} from "../../common/utils/RosterDataHelper";

/**
 * returns the teamId from the window location, if the user is not on a team page then return #.
 * If user is on crew home page i.e amazon then returns amazon team id.
 */
const getTeamId = (history: History, amazonTeamId: string): string => {
  const pathNameArray: string[] = history.location.pathname.split("/");
  const type = pathNameArray[1];
  let teamId = pathNameArray[2];
  if (type === "team" && teamId === "amazon" && amazonTeamId !== undefined) {
    teamId = amazonTeamId;
    console.log(`team id now is ${teamId}`);
  }
  return type === "team" ? teamId : "#";
};

/**
 * Get the roster endpoint corresponding to environment and teamId.
 */
const getRosterUrl = (amazonTeamId: string, history: History): string => {
  const currentEnvironment = getCurrentEnvironment();
  let url = "";
  const teamId = getTeamId(history, amazonTeamId);
  const postfix = teamId === "#" ? "#" : `team/${teamId}`;
  if (getCurrentEnvironment() === Environment.Test) {
    url = `https://alpha.roster2.a2z.com/${postfix}`;
  } else if (
    [Environment.Alpha, Environment.Beta, Environment.Gamma].includes(
      currentEnvironment
    )
  ) {
    url = `https://${currentEnvironment}.roster2.a2z.com/${postfix}`;
  } else {
    url = `https://roster2.a2z.com/${postfix}`;
  }
  return url;
};

const Header: React.FC<RouteComponentProps> = ({ history }): JSX.Element => {
  const searchBarSuggestionOnclick = (suggestion: AutoSuggestItem): void => {
    history.push(`/team/${suggestion.urlId}`);
  };

  // Eliminating the call to searchService by fetching this id from the defined config
  const definedPresets: DefinedPresets = getDefinedPresets();

  // Usage: In the AppLaunchPopover which opens the corresponding link in Roster
  const { amazonTeamId } = definedPresets;

  // TODO: update divs to PolarisV3 components
  return (
    <div className={styles["header_external"]}>
      <div className={styles["header-page-wrapper"]}>
        <div className={styles["crowd_header"]}>
          <div className={styles["header-left"]}>
            <Link href="/">
              <AmazonCrewLogo />
            </Link>
            <div className={styles["search-bar-container"]}>
              <AutoSuggest
                placeholder="Search for a team"
                suggestionOnClick={searchBarSuggestionOnclick}
                searchQueryMinLength={3}
                suggestionTypes={[EntityType.TEAM]}
              />
            </div>
          </div>
          <div className={styles["header-right"]}>
            <div className={styles["header-links"]}>
              <Link
                external
                href={getRosterUrl(amazonTeamId, history)}
                color="inverted"
              >
                Roster
              </Link>
              <Link href="/system-tasks" color="inverted">
                System tasks
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default withRouter(Header);
